module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_5_B-033ee3ad4155d1fc29af8e0374d53869.gif";